// extracted by mini-css-extract-plugin
export default {"spanBlock":"SuperEditableSpan_spanBlock__3wNbb","span":"SuperEditableSpan_span__lRg4I","input":"SuperEditableSpan_input__1TD+c","pen":"SuperEditableSpan_pen__N+goT"};